import { render, staticRenderFns } from "./xiaofei_jilu.vue?vue&type=template&id=fbe2ca2c&scoped=true"
import script from "./xiaofei_jilu.vue?vue&type=script&lang=js"
export * from "./xiaofei_jilu.vue?vue&type=script&lang=js"
import style0 from "./xiaofei_jilu.vue?vue&type=style&index=0&id=fbe2ca2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe2ca2c",
  null
  
)

export default component.exports